import React from 'react';

const DemoBanner = () => {
  if (process.env.REACT_APP_DEMO_MODE !== 'true') return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 10000,
      backgroundColor: '#f59e0b',
      color: '#1c1917',
      textAlign: 'center',
      padding: '7px 16px',
      fontWeight: 700,
      fontSize: '0.8rem',
      letterSpacing: '0.06em',
      boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
      userSelect: 'none',
    }}>
      ⚠️&nbsp; DEMO-UMGEBUNG &nbsp;—&nbsp; Alle Daten sind fiktiv. Diese Instanz dient nur zur Vorführung von Fasnet.App. &nbsp;⚠️
    </div>
  );
};

export default DemoBanner;
